import React, { useEffect, useState } from 'react'
import AddItem from '../addItem/AddItem'
import TodoListItem from '../todoListItem/TodoListItem';
import "./todoList.css"
import TodoContext from '../todoCtx/TdoCtx'




const TodoList = ({dragItem}) => {

  const [ studentName, setStudentName] = useState("");
  const [ studentNameNew, setStudentNameNew] = useState("");

  const [ studentEmail, setstudentEmail ] = useState("");
  const [ studentNumber, setstudentNumber] = useState("");

  const [ studentClass, setStudentClass] = useState("");

  const [ showEditForm, setShowEditForm] = useState(false);


  const [formData, setFormData] = useState([{fullName : "", email: "", number : "", class : "", id : ""}]);


  const [showStudents, setShowStudents] = useState(false);
  

  const [students, setStudents] = React.useState( () => {
    const savedItem = localStorage.getItem("students");
    var parsedItem = []; 
    if (savedItem) {
   parsedItem = JSON.parse(savedItem); 
  }
   return parsedItem || [];

});

useEffect(() => {
  localStorage.setItem('students', JSON.stringify(students));
}, [students]);

const [showStudentsSepa, setShowStudentsSepa] = useState(false);

// const [studentsSepa, setStudentsSepa] = useState([{}]);

const [studentsSepa, setStudentsSepa] = React.useState( () => {
  const savedItem = localStorage.getItem("studentsSepa");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

useEffect(() => {
localStorage.setItem('studentsSepa', JSON.stringify(studentsSepa));
}, [studentsSepa]);

const [studentsSepaForm, setStudentsSepaForm] = React.useState( () => {
  const savedItem = localStorage.getItem("Form");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

useEffect(() => {
localStorage.setItem('studentsSepaForm', JSON.stringify(studentsSepaForm));
}, [studentsSepaForm]);

  const [storedId, setStoredId] = useState(null);

  const [writeTask, setWriteTask] = useState("");

  const [stdClasses, setStdClasses] = useState([{name: "CLASS 8"}, {name: "CLASS 9"}])

  const [markedTodos, setMarkedTodos] = useState([]);

  const [showDblList, setShowDblList] = useState(false);

  const [showClass8, setShowClass8] = useState(false);
  
  const [showRecycleBin,setShowRecycleBin] = useState(false);

  const [showForm,setShowForm] = useState(false);

  const [isShown, setIsShown] = useState(false);

  const [showCB, setShowCB] = useState(false);

  const [data, setData] = useState(false);

  const [notAllowed, setNotAllowed] = useState(false);

  const [replace, setReplace] = useState(false);

  

  const [crtDrgSection, setCrtDrgSection] = useState("");

  const [dragging, setDragging] = useState(true);

  const [copyCounter, setCopyCounter] = useState([]);
  
  
  const [todos, setTodos] = React.useState( () => {
    const savedItem = localStorage.getItem("todos");
    var parsedItem = []; 
    if (savedItem) {
   parsedItem = JSON.parse(savedItem); 
  }
   return parsedItem || [];

});

  const [compTodos, setCompTodos] = React.useState( () => {
  const savedItem = localStorage.getItem("compTodos");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

const [compTodos2, setCompTodos2] = React.useState( () => {
  const savedItem = localStorage.getItem("compTodos2");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

const [compTodosMove1, setCompTodosMove1] = React.useState( () => {
  const savedItem = localStorage.getItem("compTodosMove1");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

const [compTodosMove2, setCompTodosMove2] = React.useState( () => {
  const savedItem = localStorage.getItem("compTodosMove2");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

const [dblListItems, setDblListItems] = React.useState( () => {
  const savedItem = localStorage.getItem("dblListItems");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

const [dblListItemsSepa, setDblListItemsSepa] = React.useState( () => {
  const savedItem = localStorage.getItem("dblListItemsSepa");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

const [replaceTodos, setReplaceTodos] = React.useState( () => {
  const savedItem = localStorage.getItem("replaceTodos");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

const [dblListItemsClick, setDblListItemsClick] = React.useState( () => {
  const savedItem = localStorage.getItem("replaceTodos");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});


const [class8, setClass8] = React.useState( () => {
  const savedItem = localStorage.getItem("class8");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});

const [class9, setClass9] = React.useState( () => {
  const savedItem = localStorage.getItem("class9");
  var parsedItem = []; 
  if (savedItem) {
 parsedItem = JSON.parse(savedItem); 
}
 return parsedItem || [];

});


  
  useEffect(() => {
    localStorage.setItem('todos', JSON.stringify(todos));
  }, [todos]);

  useEffect(() => {
    localStorage.setItem('compTodos', JSON.stringify(compTodos));
  }, [compTodos]);

  useEffect(() => {
    localStorage.setItem('compTodos2', JSON.stringify(compTodos2));
  }, [compTodos2]);

  useEffect(() => {
    localStorage.setItem('compTodosMove1', JSON.stringify(compTodosMove1));
  }, [compTodosMove1]);

  useEffect(() => {
    localStorage.setItem('compTodosMove2', JSON.stringify(compTodosMove2));
  }, [compTodosMove2]);

  useEffect(() => {
    localStorage.setItem('dblListItems', JSON.stringify(dblListItems));
  }, [dblListItems]);

  useEffect(() => {
    localStorage.setItem('dblListItemsSepa', JSON.stringify(dblListItemsSepa));
  }, [dblListItemsSepa]);

  useEffect(() => {
    localStorage.setItem('replaceTodos', JSON.stringify(replaceTodos));
  }, [replaceTodos]);

  useEffect(() => {
    localStorage.setItem('class8', JSON.stringify(class8));
  }, [class8]);

  useEffect(() => {
    localStorage.setItem('class9', JSON.stringify(class9));
  }, [class9]);


  useEffect(() => {
    setDblListItemsSepa([]);
    }, []);


  return (
  
    <div className='todoListAppMain'>
      
      <h1>STUDENTS MANAGEMENT SYSTEM</h1>
  
        <div className="todoListAppConatiner">

          <TodoContext.Provider value={{todos,setTodos,writeTask,setWriteTask,compTodos,setCompTodos,crtDrgSection, setCrtDrgSection,compTodos2,setCompTodos2,compTodosMove1,compTodosMove2,setCompTodosMove1,setCompTodosMove2,dragging, setDragging, isShown, setIsShown, data, setData,markedTodos, setMarkedTodos, showCB, setShowCB, notAllowed, setNotAllowed, replace, setReplace,copyCounter, setCopyCounter, dblListItems, setDblListItems,showDblList, setShowDblList, dblListItemsSepa, setDblListItemsSepa, replaceTodos, setReplaceTodos, dblListItemsClick, setDblListItemsClick,stdClasses, setStdClasses,class8,setClass8,class9,setClass9,showRecycleBin,setShowRecycleBin, showForm,setShowForm, students, setStudents,showStudents, setShowStudents,showClass8, setShowClass8, storedId, setStoredId,showStudentsSepa, setShowStudentsSepa, studentsSepa, setStudentsSepa, formData, setFormData, studentName, setStudentName, studentsSepaForm, setStudentsSepaForm, studentClass, setStudentClass, showEditForm, setShowEditForm,studentNameNew, setStudentNameNew, studentEmail, setstudentEmail, studentNumber, setstudentNumber }}>



            {/* <AddItem/> */}

            

        
            <TodoListItem/>      
                     

          </TodoContext.Provider>

          
               


        </div>
        
      </div>
    
   
  )
}

export default TodoList